import React from "react";
import { Box, Button, Typography } from "@mui/material";

// Top-level safety net: a long-idle tab waking up to an expired session can
// trigger a burst of failed requests/state updates from several widgets at
// once. If any of that throws during render, React unmounts the whole tree
// with no trace — a blank white screen the user can only escape by manually
// reloading. This catches that and offers a one-click reload instead.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Unhandled render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          height="100vh"
          gap={2}
          textAlign="center"
          px={2}
        >
          <Typography variant="h5">เกิดข้อผิดพลาดบางอย่าง</Typography>
          <Typography color="text.secondary">
            กรุณาโหลดหน้านี้ใหม่อีกครั้ง
          </Typography>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => window.location.reload()}
          >
            โหลดหน้านี้ใหม่
          </Button>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
